import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoFileCheck = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>FileCheck</title>
    <path
      d="M26.857 12.749v14.526a2.429 2.429 0 0 1-2.428 2.429H9.57a2.429 2.429 0 0 1-2.429-2.429V6.702a2.429 2.429 0 0 1 2.43-2.428h8.475c.621 0 1.22.238 1.67.665l6.383 6.047c.484.458.758 1.096.758 1.763Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path
      d="m13.49 20.036 2.596 2.987 4.424-6.377"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.713 12.416H22.14a3.429 3.429 0 0 1-3.429-3.429V4.416"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoFileCheck;
